import React from "react";
import { Label } from "@windmill/react-ui";

const LabelArea = ({ label, required = false }) => {
  const isOptional = label.includes("(Optional)");
  const labelParts = isOptional ? label.split("(Optional)") : [label];

  return (
    <Label className="col-span-4 mb-1 text-sm">
      {labelParts[0]}
      {required && <span className="text-red-500 ml-1">*</span>}
      {isOptional && (
        <span className="text-red-500 text-sm ml-1">(Optional)</span>
      )}
    </Label>
  );
};

export default LabelArea;
